<template>
  <div class="modal fade" :id="dataTarget" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <WatermarkImage>
            <ImageCarousel show-control
                           style="min-height: 220px"
                           :img-fit-type="'contain'"
                           :img_list="img_list"
                           type="original"
            />
          </WatermarkImage>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ImageCarousel from "@/views/components/elements/ImageCarousel";
import WatermarkImage from "@/components/WatermarkImage.vue";

export default {
  name: "CommodityImageDialog",
  components: {
    ImageCarousel: ImageCarousel,
    WatermarkImage,
  },
  props: {
    dataTarget: {
      type: String,
      default: "exampleModal",
    },
    title: {
      type: String,
      default: "modal large",
    },
    context: {
      type: String,
      default: "",
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    confirmText: {
      type: String,
      default: "確認",
    },
    onlyConfirm: {
      type: Boolean,
      default: false,
    },
    img_list: {
      type: Array,
      default: () => [],
    }
  }
}
</script>

<style scoped>

</style>
